'use client'

import { Card, Pagination } from '@vinted/web-ui'
import { useRouter } from 'next/navigation'
import { useTransition } from 'react'

import { scrollToTop } from '@marketplace-web/shared/browser-util'

type Props = {
  page: number
  totalPages: number
  testId: string
  path: string
}

const PaginationComponent = ({ page, totalPages, testId, path }: Props) => {
  const router = useRouter()
  const [isLoading, startTransition] = useTransition()

  if (totalPages <= 1) return null

  const setNewPage = (newPage: number, event: React.MouseEvent<Element, MouseEvent>) => {
    event.preventDefault()
    startTransition(() => {
      router.push(`${path}?page=${newPage}`)
    })
    scrollToTop('smooth')
  }

  return (
    <div data-loading={isLoading}>
      <Card>
        <Pagination
          currentPage={page}
          pageCount={totalPages}
          urlBuilder={currentPage => `${path}?page=${currentPage}`}
          onNextClick={setNewPage}
          onPrevClick={setNewPage}
          onPageClick={setNewPage}
          testId={testId}
        />
      </Card>
    </div>
  )
}

export default PaginationComponent
